import React from 'react';
import CheckoutContainer from '../../../Componant/Ecommerce/Checkout';

const Checkout = () => {
  return (
    <div className='page-body'>
      <CheckoutContainer />
    </div>
  );
};

export default Checkout;
